import "../assets/styles/Education.scss";
import { itemsData } from "../data/educationData"; // importa el array

const AllEducationCertificates = () => {
  const featuredItems = itemsData.filter((item) => item.featured);
  const educationItems = itemsData.filter((item) => item.type === "education");
  const certificateItems = itemsData.filter((item) => item.type === "certificate");
  
  const renderCard = (item: any, isFeatured = false) => (
  <div key={item.id} className={`card${isFeatured ? " featured" : ""}`}>
    {item.image && (
      <img src={item.image} alt={item.issuer} className="card-image" />
    )}
    <div className="card-content">
      <h3>{item.title}</h3>
      <h4>{item.issuer}</h4>
      <p className="date">{item.date}</p>
      
      {item.description && (
        <p style={{ color: "rgb(39, 40, 34)" }}>{item.description}</p>
      )}
        {item.topic && (
        <p style={{ color: "rgb(39, 40, 34)" }}>{item.topic}</p>
      )}
      <p
        style={{
          fontStyle: "italic",
          color: "#000",
          fontSize: "0.8rem",
        }}
      >
      <p
        style={{
          fontStyle: "italic",
          color: "#000",
          fontSize: "0.8rem",
        }}
      ></p>
        {item.type === "education" ? "Education" : "Certificate"}
      </p>
      {item.link && (
        <p>
          <a href={item.link} target="_blank" rel="noreferrer" className="link">
            View Certificate
          </a>
        </p>
      )}
    </div>
  </div>
);

  return (
    <div id="all-education-certificates" className="items-container">
      <h1>All Education & Certificates</h1>

      {/* Destacados */}
        <section className="cards-section">
          <h2>Destacados</h2>
          <div className="cards-grid">
            {featuredItems.map((item) => renderCard(item, true))}
          </div>
        </section>

        {/* Educación */}
        <section className="cards-section">
          <h2>Education</h2>
          <div className="cards-grid">
            {educationItems.map((item) => renderCard(item, false))}
          </div>
        </section>

        {/* Certificados */}
        <section className="cards-section">
          <h2>Certificates</h2>
          <div className="cards-grid">
            {certificateItems.map((item) => renderCard(item, false))}
          </div>
        </section>
    </div>
  );
};

export default AllEducationCertificates;

